import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { Row, Col, Button } from 'bootstrap';
import classnames from 'classnames';
import GlobalElementMetricsStore from 'shared/flux/stores/GlobalElementMetricsStore';
import GlobalElementMetricsActions from 'shared/flux/actions/GlobalElementMetricsActions';
import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import PublishGlobalElementsActions from 'flux/actions/PublishGlobalElementsActions';
import UIRegions from 'shared/constants/UIRegions';
import ModalActions from 'shared/flux/actions/ModalActions';
import { DateFormatter } from 'shared/lib/dateFormatter';
import RouteActions from 'shared/flux/actions/RouteActions';
import { ViewTypes, ViewRelativePaths } from 'shared/constants/CuesheetViews';

const activeEvents = 'activeEvents';
const pastEvents = 'pastEvents';

/**
 * Global Element Footer
 *
 */
export default React.createClass({
  displayName: 'GlobalElementFooter',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    PureRenderMixin,
    Reflux.connect(GlobalElementMetricsStore, 'metrics'),
    Reflux.connect(CuesheetStore, 'cuesheet'),
  ],

  getInitialState() {
    return {
      expanded: false,
      eventTab: activeEvents,
    };
  },

  render() {
    const { expanded } = this.state;

    return (
      <footer
        id="ge-metrics-footer"
        className={classnames({ expanded: expanded })}
      >
        {expanded ? this._getExpandedMetricsNode() : this._getMetricsNode()}
      </footer>
    );
  },

  _getExpandedMetricsNode(fakeSumMetrics) {
    const { eventTab } = this.state;

    return (
      <div>
        {this._getMetricsHeader()}
        <Row>
          <Col lg={4} md={4} sm={4}>
            <Row>
              <Col lg={24} md={24} sm={24}>
                <h3 className="ge-metrics-title-expanded">Summary Metrics</h3>
              </Col>
            </Row>
            <Row>
              <Col lg={24} md={24} sm={24}>
                {this._getSumMetrics(fakeSumMetrics)}
              </Col>
            </Row>
          </Col>
          <Col lg={10} md={10} sm={10}>
            <Row>
              <Col lg={24} md={24} sm={24}>
                <h3
                  className={classnames('ge-metrics-title-expanded', {
                    active: eventTab === activeEvents,
                  })}
                  onClick={() => this.setState({ eventTab: activeEvents })}
                >
                  Active Events
                </h3>
                <h3
                  className={classnames('ge-metrics-title-expanded', {
                    active: eventTab === pastEvents,
                  })}
                  onClick={() => this.setState({ eventTab: pastEvents })}
                >
                  Past Events
                </h3>
              </Col>
            </Row>
            <Row className="ge-metrics-event-list">
              <Col lg={24} md={24} sm={24}>
                {this._getEventItems()}
              </Col>
            </Row>
          </Col>
          {/*
            https://github.com/SHOFLO/Issues/issues/4222
            <Col lg={10} md={10} sm={10}>
              <Row>
                <Col lg={24} md={24} sm={24}>
                  <h3 className="ge-metrics-title-expanded">Proofs of Performance</h3>
                </Col>
              </Row>
              <Row className="ge-metrics-proofs-list">
                <Col lg={24} md={24} sm={24}>
                  {this._getProofPerformanceItems()}
                </Col>
              </Row>
            </Col>


            */}
        </Row>
      </div>
    );
  },

  _getProofPerformanceItems() {
    const { metrics } = this.state;

    return metrics.get('proofShowItems').map((showItem, showItemId) => {
      const createdBy = showItem.getIn(['proof', 'createdBy']);
      const proofName = `${createdBy.get('firstName')} ${createdBy.get(
        'lastName',
      )}`;
      const proofNote = showItem.getIn(['proof', 'note']) || '';

      return (
        <span key={showItemId}>
          <Row className="ge-metrics-past-events-item">
            <Col lg={8} md={8} sm={8}>
              <div
                className="ge-metrics-past-events-title"
                onClick={
                  () =>
                    /* eslint-disable no-undef */
                    RouteActions.goToShow({
                      teamId,
                      eventId,
                      showId,
                      relativePath: ViewRelativePaths[ViewTypes.Compact],
                    })
                  /* eslint-enable no-undef */
                }
              >
                {showItem.getIn(['show', 'title'])}
              </div>
              <div className="ge-metrics-past-events-text">
                {DateFormatter(
                  showItem.getIn(['proof', 'createdOn']),
                  'HH:mm:ssA',
                )}
              </div>
              <div className="ge-metrics-past-events-text">{proofName}</div>
              <div className="ge-metrics-past-events-text">{proofNote}</div>
            </Col>
            <Col lg={12} md={12} sm={12}>
              <div
                className="ge-metrics-past-events-text event"
                onClick={
                  () =>
                    /* eslint-disable no-undef */
                    RouteActions.goToEvent({
                      teamId,
                      eventId,
                    })
                  /* eslint-enable no-undef */
                }
              >
                {showItem.getIn(['event', 'title'])}
              </div>
            </Col>
          </Row>
          <div className="ge-metrics-past-events-item-line"></div>
        </span>
      );
    });
  },

  _getEventItems() {
    const { metrics, eventTab } = this.state;
    const { teamId } = this.context.router.state.params;

    return metrics.get(eventTab).map((eventItem, eventId) => {
      const dateFormat = 'M/D/YY';
      const event = eventItem.get('event');

      const showNodes = eventItem.get('items').map((item, itemId) => {
        return (
          <div
            key={itemId}
            className="ge-metrics-past-events-text show"
            onClick={() =>
              RouteActions.goToShow({
                teamId,
                eventId: item.getIn(['event', '_id']),
                showId: item.getIn(['show', '_id']),
                relativePath: ViewRelativePaths[ViewTypes.Compact],
              })
            }
          >
            {item.getIn(['show', 'title'])}
          </div>
        );
      });

      return (
        <div key={eventId}>
          <Row className="ge-metrics-past-events-item">
            <Col lg={8} md={8} sm={8}>
              <div
                className="ge-metrics-past-events-title"
                onClick={() =>
                  RouteActions.goToEvent({
                    teamId,
                    eventId,
                  })
                }
              >
                {event.get('title')}
              </div>
              {showNodes}
            </Col>
            <Col lg={12} md={12} sm={12}>
              <div className="ge-metrics-past-events-text date">
                {DateFormatter(event.get('startOn'), dateFormat)} -{' '}
                {DateFormatter(event.get('endOn'), dateFormat)}
              </div>
            </Col>
          </Row>
          <div className="ge-metrics-past-events-item-line"></div>
        </div>
      );
    });
  },

  _getMetricsNode() {
    return (
      <div>
        {this._getMetricsHeader()}

        <Row>
          <Col lg={24} md={24} sm={24}>
            {this._getSumMetrics()}
          </Col>
        </Row>
      </div>
    );
  },

  _getSumMetrics() {
    const metrics = this._getSummaryMetricsData();

    return (
      <div>
        <div className="ge-metrics-totals">
          <span className="ge-metrics-totals-num">
            {metrics.activeShowsCount}
          </span>{' '}
          - Active Shows
        </div>
        <div className="ge-metrics-totals">
          <span className="ge-metrics-totals-num">
            {metrics.pastShowsCount}
          </span>{' '}
          - Past Shows
        </div>
        <div className="ge-metrics-totals">
          <span className="ge-metrics-totals-num">
            {metrics.totalShowsCount}
          </span>{' '}
          - Total Shows
        </div>
        {/*
          https://github.com/SHOFLO/Issues/issues/4222
          <div className="ge-metrics-totals">
            <span className="ge-metrics-totals-num">
              {metrics.proofsCount}
            </span> - Performed Time Stamps
          </div>
          */}
      </div>
    );
  },

  _getMetricsHeader() {
    const { expanded } = this.state;
    // const revealBtnTitle = expanded ? 'Collapse Metrics' : 'Reveal All Metrics';

    const activeItem = this._getActiveItem();

    if (!activeItem) return null;

    let activeItemTitle = activeItem.get('title')
      ? activeItem.get('title')
      : 'Item';
    if (activeItem.get('titleView')) activeItemTitle = 'Title Row';

    return (
      <Row>
        <Col lg={12} md={12} sm={12}>
          <h3 className="ge-metrics-title">{activeItemTitle}</h3>

          {expanded ? (
            <div className="ge-metrics-subtitle-expanded-main">
              Element Metrics
            </div>
          ) : null}
        </Col>
        <Col lg={11} md={11} sm={11}>
          <div className="ge-metrics-btn-wrapper">
            {/* Re-enable once we have finished designs for the expanded view...
            <Button
              className="ge-metrics-button"
              onClick={this._handleExpand}>
              {revealBtnTitle}
            </Button>*/}
            {/* Re-enable once export is hooked up
                <Button
              className="ge-metrics-button"
              onClick={() => this._export()}
            >
              Export Element Metrics
            </Button>*/}
            <Button
              className="ge-metrics-button primary"
              onClick={() => this._publish()}
            >
              Publish
            </Button>
          </div>
        </Col>
      </Row>
    );
  },

  _handleExpand() {
    GlobalElementMetricsActions.populate();
    this.setState({ expanded: !this.state.expanded });
  },

  _getSummaryMetricsData() {
    const { metrics } = this.state;

    let activeShowsCount = 0;
    let pastShowsCount = 0;

    metrics.get('activeEvents').forEach((eventItem) => {
      activeShowsCount += eventItem.get('items').size;
    });

    metrics.get('pastEvents').forEach((eventItem) => {
      pastShowsCount += eventItem.get('items').size;
    });

    const totalShowsCount = activeShowsCount + pastShowsCount;
    const proofsCount = metrics.get('proofShowItems').size;

    return { activeShowsCount, pastShowsCount, totalShowsCount, proofsCount };
  },

  _getActiveItem() {
    const { metrics, cuesheet } = this.state;

    return cuesheet.getIn([
      'rowMap',
      metrics.get('itemSetId'),
      'rows',
      metrics.get('rowId'),
      'item',
    ]);
  },

  _publish() {
    ModalActions.show(UIRegions.PublishGEChanges);
    PublishGlobalElementsActions.populate();
  },
});
